import { createApp, ref } from "vue";
import App from "./App.vue";
import router from "./route";
import store from "./store";
import VueSweetalert2 from "vue-sweetalert2";
import Vue3PersianDatetimePicker from "vue3-persian-datetime-picker";
import "sweetalert2/dist/sweetalert2.min.css";
import Select2 from "vue3-select2-component";
import "../src/assets/css/all.css";
import "../src/assets/css/animate.min.css";
import "../src/assets/css/bootstrap.min.css";
import "../src/assets/css/style.css";
const app = createApp(App);
app.config.globalProperties.$loading = ref(false);
app
  .use(router)
  .use(store)
  .use(VueSweetalert2)
  .use(Vue3PersianDatetimePicker, {
    name: "CustomDatePicker",
    props: {
      format: "YYYY-MM-DD",
      displayFormat: "jYYYY-jMM-jDD",
      editable: false,
      inputClass: "form-control my-custom-class-name",
      placeholder: "Please select a date",
      altFormat: "YYYY-MM-DD",
      color: "#8f6008",
      autoSubmit: false,
    },
  })
  .use(Select2)
  .mount("#app");

export default app;
